import LoginRegister from '@components/login-register/LoginRegister';
import { CacheProvider } from '@emotion/react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import theme from '@ui/theme';
import { createMuiCache } from '@utils/createMuiCache';
import { User as FirebaseUser } from 'firebase/auth';
import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';


const awaitUserLogin = (userContext: UserContext, {
  title = 'Please login or register to continue',
} = {}) => new Promise<FirebaseUser>((resolve, reject) => {

  if (userContext.user?.uid) {
    resolve(userContext.user);
    return;
  }

  const portal = document.createElement('div');


  portal.id = 'login-modal';
  document.body.appendChild(portal);

  const cleanup = () => {
    setTimeout(() => {
      document.body.removeChild(portal);
    }, 3000);
  };

  const Modal = ({ resolve, reject }) => {
    const [open, setOpen] = useState(true);

    return (
      <CacheProvider value={createMuiCache()}>
        <ThemeProvider theme={theme}>
          <Dialog
            fullWidth
            open={open}
            maxWidth="sm"
            onClose={() => {
              setOpen(false);
              reject();
              cleanup();
            }}
          >
            <DialogContent style={{ marginBottom: theme.spacing(2) }}>
              <Typography variant="h6Alt">
                {title}
              </Typography>

              <LoginRegister
                onLoginSuccess={(user: FirebaseUser) => {
                  setOpen(false);
                  resolve(user);
                  cleanup();
                }}
              />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
      </CacheProvider>
    );
  };

  const root = createRoot(portal);

  root.render(<Modal
    resolve={resolve}
    reject={reject}
  />);
});

export default awaitUserLogin;
